import { render, staticRenderFns } from "./ConfirmCandidateAllocationDialog.vue?vue&type=template&id=269ea8fd&"
import script from "./ConfirmCandidateAllocationDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmCandidateAllocationDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmCandidateAllocationDialog.vue?vue&type=style&index=0&id=269ea8fd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports